module.exports = __webpack_public_path__ + "static/media/activitiy-list-bg.fa19b4bc.jpg";